import type { Ctx } from "../../types";
import { Action, invalidate } from "gg-wf-scripts";
import { toast } from "../../toast";

export const mark_approved_unpaid_as_paid: Action<Ctx> = async ({ sb }) => {
  const { data, error } = await sb
    .from("job_openings")
    .update({ pay_status: "paid" })
    .eq("review_status", "approved")
    .eq("pay_status", "unpaid")
    .is("deleted_at", null)
    .select("id");

  if (error) {
    toast({ variant: "error", text: "Bulk pay update failed. Try again" });
    return { ok: false, error: error.message };
  }

  const count = data?.length ?? 0;
  if (count === 0) {
    toast({
      variant: "warning",
      text: "No approved & unpaid jobs to pay.",
    });
    return { ok: true };
  }

  invalidate("jobs");
  toast({
    variant: "success",
    text: `Marked ${count} job${count === 1 ? "" : "s"} paid.`,
  });
  return { ok: true };
};
